import { useRouter } from 'next/router'
import { type FC, useEffect } from 'react'

import { Text } from '@wartek-id/text-v1'

import CompetencyCard from 'app/PemetaanKompetensiPage/components/AsesmenRefleksi/CompetencyCard'
import PeriodGuard from 'app/PemetaanKompetensiPage/components/AsesmenRefleksi/PeriodGuard'
import { CompetencyIcons } from 'app/PemetaanKompetensiPage/constants/CompetencyIcons'
import { useApiCompetencyMappingAssessmentStatus } from 'api/competency-mapping/useAPICompetencyMapping'
import { useAsesmenRefleksiPeriod } from 'app/PemetaanKompetensiPage/hooks/useAsesmenRefleksiPeriod'
import { useSETrackEventRefkom } from '../../hooks/useSETrackEventRefkom'

const ASSESSMENT_ROUTE = '/refleksi-kompetensi/asesmen-refleksi'
interface MainProps {
  currentDateTimeServer: string
}

const Main: FC<MainProps> = ({ currentDateTimeServer }) => {
  const router = useRouter()
  const { trackAsessmentMenuOpen } = useSETrackEventRefkom()

  const { isLoading, isSuccess, data } =
    useApiCompetencyMappingAssessmentStatus('REFLEKSI')

  useEffect(() => {
    if (isSuccess) {
      trackAsessmentMenuOpen()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  const { deadlineDate } = useAsesmenRefleksiPeriod(currentDateTimeServer)

  return (
    <PeriodGuard currentDateTimeServer={currentDateTimeServer} fullPageLoading>
      <div className="m-auto max-w-ujikom flex flex-col pb-6 p-4">
        <div className="rounded-lg bg-orange-10 p-3 mb-5">
          <Text>
            Refleksi Kompetensi belum berdampak langsung ke pangkat/jenjang
            profesi dan Rapor Pendidikan.
            <br />
            <br />
            Pastikan refleksi terkumpul sebelum:
            <br />
            <Text as="span" variant="body-bold">
              {deadlineDate}.
            </Text>
          </Text>
        </div>
        <Text variant="heading-sm" className="mb-2">
          Mari mulai refleksi!
        </Text>
        <Text variant="body-sm">
          Anda bisa utamakan kompetensi yang sesuai dengan minat dan
          pengembangan diri pribadi.
        </Text>

        <div className="mt-4">
          {!isLoading &&
            data?.data.map((thisAssessmentStatus, index) => (
              <CompetencyCard
                key={`assessment_${index}`}
                name={thisAssessmentStatus.label}
                className="mb-3"
                status={thisAssessmentStatus.status}
                notes={`halaman ${thisAssessmentStatus.filledPages || 1}/${
                  thisAssessmentStatus.totalPages
                }.`}
                onClick={() => {
                  if (thisAssessmentStatus.status === 'NOT_CREATED') {
                    router.push(
                      `${ASSESSMENT_ROUTE}/data-diri/${thisAssessmentStatus.label.toLowerCase()}`
                    )
                    return
                  }
                  router.push(
                    `${ASSESSMENT_ROUTE}/${thisAssessmentStatus.label.toLowerCase()}`
                  )
                }}
                icon={CompetencyIcons[thisAssessmentStatus.label.toLowerCase()]}
              />
            ))}
        </div>
      </div>
    </PeriodGuard>
  )
}
export default Main
